import { Controller } from '@hotwired/stimulus';

export class BaseController extends Controller {
  dispatch(
    eventName: string,
    config?:
      | Partial<{
          target: Element | Window | Document;
          detail: Object;
          bubbles: boolean;
          cancelable: boolean;
        }>
      | undefined
  ): CustomEvent<Object> {
    this.logger(`@${eventName}`, config);

    const updatedConfig = {
      ...config,
      prefix: '',
    };

    return super.dispatch(eventName, updatedConfig);
  }

  protected logger(
    message,
    details?: {} | null,
    color: string = '#a2dbff'
  ): void {
    console.groupCollapsed(
      `%c${message}`,
      `color: ${color}; font-weight: bold;`
    );

    if (details) {
      console.log('details:', details);
    }

    console.groupEnd();
  }
}
